import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./i18n";
import { BrowserRouter as Router } from "react-router-dom";
import { reactQueryClient } from "./service";
import { QueryClientProvider } from "react-query";
import { AppContextProvider } from "./contexts/AppContextProvider";
import { ThemeContextProvider } from "./contexts/theme-context/ThemeContextProvider";
import "./index.css";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import * as Sentry from "@sentry/react";
import { ErrorFilterProvider } from "./contexts/error-filter-context/ErrorFilterContext";
import { HelmetProvider } from "react-helmet-async";
import { purgeOutdatedLastOrders } from "./utils/lastOrder";

dayjs.extend(utc);
dayjs.extend(timezone);

// Usuń z localStorage zapisane zamówienia w starym formacie (bez rozbicia
// cen dodatków), zanim ktokolwiek je odczyta — chroni przed ponowieniem
// zamówienia po błędnej cenie.
purgeOutdatedLastOrders();

// Defer Sentry init to avoid blocking startup
// Only initialize in production environment
if (process.env.NODE_ENV === 'production') {
  // Initialize after page becomes interactive to avoid blocking render
  if (document.readyState === 'complete') {
    initSentry();
  } else {
    window.addEventListener('load', initSentry);
  }
}

function initSentry() {
  Sentry.init({
    dsn: "https://8b5722b751b9e808ac0966110e278ff0@o4510403202449408.ingest.de.sentry.io/4510403216015440",
    sendDefaultPii: true,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Reduced sample rates for better performance in production
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
    tracesSampleRate: 0.2, // 20% of transactions for performance monitoring
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <ErrorFilterProvider>
    <HelmetProvider>
      <ThemeContextProvider>
        <AppContextProvider>
          <QueryClientProvider client={reactQueryClient}>
            <Router>
              <App />
            </Router>
          </QueryClientProvider>
        </AppContextProvider>
      </ThemeContextProvider>
    </HelmetProvider>
  </ErrorFilterProvider>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("Service Worker registered:", registration);
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  });
}
